(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('PaymentLinkReadyModalController', PaymentLinkReadyModalController);

    /** @ngInject */
    function PaymentLinkReadyModalController($rootScope, $state, $uibModalInstance, paymentLinkData, systemConstants) {
        var vm = this;

        vm.$onInit = init;

        vm.closeModal = closeModal;

        function init() {
            vm.paymentLinkData = paymentLinkData;
            vm.imageUrl = systemConstants.SYSTEM_IMAGES_BASE_URL + $rootScope.urlImage + '/pedidos.png';
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
            $state.go('invoices');
        }
    }
})();
